export class FormConstants{
    static sovosFormUrl = "//go.sovos.com";
    static sovosAccountId = "334-HVN-249";
    static sovosFormText = "mktoForm_";
    static formsIdByLang = new Map<string, string>([
        ['pt', '3953'],
        ['en', '3949']
    ]);
}